/**
 * File main-navigation.js.
 *
 * Handles toggling the navigation menu for small screens and enables TAB key
 * navigation support for dropdown menus.
 *
 * @package wildrivers
 */

export function mainNavigation() {

	const siteNavigation = document.getElementById( 'site-navigation' );
	if ( ! siteNavigation ) {
		return;
	}

	const button = siteNavigation.getElementsByTagName( 'button' )[ 0 ];
	if ( 'undefined' === typeof button ) {
		return;
	}

	const menu = siteNavigation.getElementsByTagName( 'ul' )[ 0 ];
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}
	if ( ! menu.classList.contains( 'nav-menu' ) ) {
		menu.classList.add( 'nav-menu' );
	}

	// wrapper
	const body = document.getElementsByTagName('body')[0];

	// add a "close button" to the mobile menu.
	const closeWrapper = document.createElement('li');
	closeWrapper.classList.add('mobile-close-button');
	
	const closeButton = document.createElement('button');
	closeButton.classList.add('btn', 'btn-plain');
	
	const closeButtonText = document.createElement('span');
	closeButtonText.innerText = "Close";
    closeButtonText.classList.add( 'screen-reader-text' );

	const closeButtonIcon = document.createElement('span');
    closeButtonIcon.classList.add( 'close-button-icon' );

	closeButton.appendChild(closeButtonText);
	closeButton.appendChild(closeButtonIcon);

	closeWrapper.appendChild(closeButton);

	menu.prepend(closeWrapper);

	closeButton.addEventListener( 'click', handleCloseMenu );
	function handleCloseMenu() {
		siteNavigation.classList.remove( 'toggled' );
		button.setAttribute( 'aria-expanded', 'false' );
		body.classList.remove( 'mobile-menu-expanded' );
	}

	
	const links = menu.getElementsByTagName( 'a' );
	const linksWithChildren = menu.querySelectorAll(
		'.menu-item-has-children.depth-0 > a, .page_item_has_children.depth-0 > a, .menu-item-has-children.depth-0 > span, .page_item_has_children.depth-0 > span'
	);
	const listWithChildren = menu.querySelectorAll(
		'.menu-item-has-children.depth-0, .page_item_has_children.depth-0'
	);
	const topLevelLinks = menu.querySelectorAll(
		'.depth-0 > a'
	);

	const mediaQueryList = window.matchMedia( '(max-width: 999px)' );
	mediaQueryList.addEventListener( 'change', handleSizeChange );
	handleSizeChange( mediaQueryList );

	let activeHoverMenu = '';

	/**
	 * Enable and disable the click menu handler.
	 */
	function handleSizeChange(mql) {
		if (mql.matches) {
			enableClickMenu();
		} else {
			disableClickMenu();
		}
	}

	/**
	 * Turn the click menu on (mobile)
	 */
	function enableClickMenu() {
	
		button.addEventListener( 'click', toggleMobileMenu, false );

		document.addEventListener( 'click', handleClickMenuClose, false );
	
		// Toggle focus each time a menu link is focused or blurred.
		for ( const link of links ) {
			link.addEventListener( 'focus', toggleFocus, true );
			link.addEventListener( 'blur', toggleFocus, true );
		}
	
		// Toggle the submenu when a menu link with children receive a touch event.
		for ( const link of linksWithChildren ) {
			link.addEventListener( 'click', toggleSubNav, false );
		}

		for ( const item of listWithChildren ) {
			item.removeEventListener( 'mouseenter', toggleSubNavList, false );
			item.removeEventListener( 'mouseleave', closeHoverMenu, true );
		}
	}

	/**
	 * Turn the click menu off, add hover event listeners (desktop)
	 */
	function disableClickMenu() {

		button.removeEventListener( 'click', toggleMobileMenu, false );

		document.removeEventListener( 'click', handleClickMenuClose, false );
	
		for ( const link of links ) {
			link.removeEventListener( 'focus', toggleFocus, true );
			link.removeEventListener( 'blur', toggleFocus, true );
		}
		for ( const link of linksWithChildren ) {
			link.removeEventListener( 'click', toggleSubNav, false );
		}

		for ( const item of listWithChildren ) {
			item.addEventListener( 'mouseenter', toggleSubNavList, false );
			item.addEventListener( 'mouseleave', closeHoverMenu, true );
		}
	}

	/**
	 * Button open/close event listener.
	 * Toggle the .toggled class and the aria-expanded value each time the button is clicked.
	 */
	function toggleMobileMenu() {
		siteNavigation.classList.toggle( 'toggled' );
		body.classList.toggle( 'mobile-menu-expanded' );
		
		if ( button.getAttribute( 'aria-expanded' ) === 'true' ) {
			button.setAttribute( 'aria-expanded', 'false' );
		} else {
			button.setAttribute( 'aria-expanded', 'true' );
		}
	}

	/**
	 * Remove the .toggled class and set aria-expanded to false when the user clicks outside the navigation.
	 */
	function handleClickMenuClose( event ) {
		const isClickInside = siteNavigation.contains( event.target );

		if ( ! isClickInside ) {
			siteNavigation.classList.remove( 'toggled' );
			body.classList.remove( 'mobile-menu-expanded' );
			button.setAttribute( 'aria-expanded', 'false' );
		}
	}

	/**
	 * Opens and closes subNav
	 */
	function toggleSubNav(event) {
		event.preventDefault();
		if ( event.target.parentNode.classList.contains('sub-menu-open') ) {
			event.target.parentNode.classList.remove('sub-menu-open');
			menu.classList.remove('sub-menu-open');
		} else {
			menu.childNodes.forEach( (el) => {
				if ( el.nodeType === 1 ) {
					el.classList.remove('sub-menu-open');
				}
			});
			event.target.parentNode.classList.add('sub-menu-open');
			menu.classList.add('sub-menu-open');
		}
	}

	/**
	 * hover open/close subnav
	 */
	function toggleSubNavList(event) {
		event.preventDefault();
		activeHoverMenu = event.target.id;
		
		menu.childNodes.forEach( (el) => {
			if ( el.nodeType === 1 ) {
				el.classList.remove('sub-menu-open');
			}
		});
		event.target.classList.add('sub-menu-open');
		menu.classList.add('sub-menu-open');
	}

	/**
	 * Close menu when leaving menu hover.
	 */
	function closeHoverMenu( event ) {
		setTimeout(
			function() {
				if ( event.target.id == activeHoverMenu ) {
					menu.childNodes.forEach( (el) => {
						if ( el.nodeType === 1 ) {
							el.classList.remove('sub-menu-open');
						}
					});
					menu.classList.remove('sub-menu-open');
					activeHoverMenu = '';
				}
			}, 300
		);
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus(event) {
		if ( event.type === 'focus' || event.type === 'blur' ) {
			let self = this;
			// Move up through the ancestors of the current link until we hit .nav-menu.
			while ( ! self.classList.contains( 'nav-menu' ) ) {
				// On li elements toggle the class .focus.
				if ( 'li' === self.tagName.toLowerCase() ) {
					self.classList.toggle( 'focus' );
				}
				self = self.parentNode;
			}
		}

		if ( event.type === 'touchstart' ) {
			const menuItem = this.parentNode;
			event.preventDefault();
			for ( const link of menuItem.parentNode.children ) {
				if ( menuItem !== link ) {
					link.classList.remove( 'focus' );
				}
			}
			menuItem.classList.toggle( 'focus' );
		}
	}
}
